import classNames from "classnames";
import type React from "react";
import "./SideTab.css";

type SideTabProps = {
    children: React.ReactNode;
    className?: string;
};
function SideTab(props: SideTabProps) {
    const { className, children } = props;
    return <div className={classNames("tab side-tab", className)}>{children}</div>;
}

export default SideTab;
